import React from 'react';
import {incrementLoginStep} from "../../Features/Misc/loginSlice";
import {useDispatch} from "react-redux";

export default function NextStepButton(props) {
    const {
        positionClassNames,
        styleClassNames,
        pClassNames,
        iClassNames,
        pContent
    } = props;


    const dispatch = useDispatch();

    return (
        <button onClick={() => dispatch(incrementLoginStep())} className={`  ${positionClassNames} ${styleClassNames} hover:opacity-60 transition-opacity duration-300 `}>
            <div className={`${pClassNames}`}>{pContent}</div>
            <i className={`${iClassNames}`}></i>
        </button>
    );
}